import moment from 'moment'
import * as React from 'react'

import { Hidden, Visible } from 'main/ui'
import { Container, Row } from './FootnoteSection.styles'
import { StyledNativeLink } from './styles'

function FirstGroup() {
  return (
    <React.Fragment>
      <StyledNativeLink href="/terms-of-use">Terms</StyledNativeLink>
      <span>·</span>
      <StyledNativeLink href="/privacy-policy">Privacy</StyledNativeLink>
    </React.Fragment>
  )
}

function SecondGroup() {
  return (
    <React.Fragment>
      <span>©{moment().year()} Wonderschool</span>
      <span>·</span>
      <span>All rights reserved.</span>
    </React.Fragment>
  )
}

function FootnoteSection() {
  return (
    <Container>
      <Visible lg xl>
        <FirstGroup />
      </Visible>
      <Hidden lg xl>
        <Row>
          <FirstGroup />
        </Row>
      </Hidden>

      <Visible lg xl>
        <span>·</span>
      </Visible>

      <Visible lg xl>
        <SecondGroup />
      </Visible>
      <Hidden lg xl>
        <Row>
          <SecondGroup />
        </Row>
      </Hidden>
    </Container>
  )
}

export default React.memo(FootnoteSection)
